export const COGNOS_CONFIG_FIELDS = Object.freeze({
  EXCLUDED: 'excluded',
  IGNORED: 'ignored',
  COMMENT: 'comment',
});



// WEBPACK FOOTER //
// ./src/components/config_central/cognos_config/constants.jsx